import React, { FC, PropsWithChildren, useEffect } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { View } from "@tarojs/components";

import { Fade, Slide } from "../Animated";
import { SlideDirection } from "../Animated/Slide";
import Mask from "../Mask";

import "./index.scss";

export type PopupPosition = "top" | "bottom" | "left" | "right";

export interface PopupProps extends PropsWithChildren<{}> {
  visible: boolean;
  position?: PopupPosition;
  className?: string;
  onClose?: () => void;
}

const positionMap = {
  top: "down",
  bottom: "up",
  left: "right",
  right: "left",
};

const Popup: FC<PopupProps> = props => {
  const { visible, position = "bottom", children, onClose, className } = props;
  const direction = positionMap[position] as SlideDirection;
  const cls = classNames("xh-popup-content", {
    "xh-popup-content-left": position === "left",
    "xh-popup-content-right": position === "right",
    "xh-popup-content-top": position === "top",
    "xh-popup-content-bottom": position === "bottom",
  });

  const preventSTH = (e: TouchEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

  useEffect(() => {
    if (visible) {
      document.body.style.touchAction = "none";
      document.body.addEventListener("touchmove", preventSTH);
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.touchAction = "";
      document.body.removeEventListener("touchmove", preventSTH);
      document.body.style.overflowY = "auto";
    }

    return () => {
      document.body.style.touchAction = "";
      document.body.style.overflowY = "auto";
      document.body.removeEventListener("touchmove", preventSTH);
    };
  }, [visible]);

  function handleClickOnMask(): void {
    onClose && onClose();
  }
  if (process.env.TARO_ENV !== "h5") {
    const minicls = classNames(
      "xh-popup",
      className,
      visible ? "visible" : "hidden"
    );
    return (
      <View className={minicls}>
        <Mask onClick={handleClickOnMask} />
        <View className={cls}>{children}</View>
      </View>
    );
  }
  return ReactDOM.createPortal(
    <Fade in={visible}>
      <div className={classNames("xh-popup", className)}>
        <Mask onClick={handleClickOnMask} />
        <Slide direction={direction} in={visible}>
          <div className={cls}>{children}</div>
        </Slide>
      </div>
    </Fade>,
    document.body
  );
};

export default Popup;
